export enum Severity {
  info = "info",
  important = "important",
  warning = "warning",
}
